import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NewmemberService } from '../../services/newmember.service';
import {MembershipService} from '../../services/membership.service';
import { UserService } from '../../services/user.service';
import domtoimage from 'dom-to-image';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import jsPDF from 'jspdf';

declare var JsBarcode:any;

@Component({
  selector: 'app-sendsms',
  templateUrl: './sendsms.component.html',
  styleUrls: ['./sendsms.component.css']
})
export class SendsmsComponent implements OnInit {
  cardDetails: any = {};
  OTPverified: boolean = false;
  photo: string;
  membershipId:number;
  phoneNbr: any;
  ecardValue: string;
  otpGenerated:boolean=false;
  documentLoaded: boolean = false;
  private element: HTMLImageElement;
  @ViewChild('canvas') canvasRef: ElementRef;
  @ViewChild('primaryImg') primaryImg: ElementRef;
  @ViewChild('addonImg') addonImg: ElementRef;
  status:string;
  documentId:number;
  memebershipStatus:string;
  cardNo:number;
  membershipNbr:number;
  
  public context: CanvasRenderingContext2D;
  constructor(private datePipe: DatePipe, public messageService: MessageService, public  translateService: TranslateService,public activatedRoute: ActivatedRoute, public nms: NewmemberService, public user: UserService, public memberService: MembershipService) { }

  ngOnInit() {
    this.element = this.primaryImg.nativeElement;
    this.membershipNbr = this.activatedRoute.snapshot.params.memberId;
    this.cardNo = this.activatedRoute.snapshot.params.cardId;
    this.translateService.use("en");
    this.cardDetails = null;
    
    this.user.getUserContent().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        localStorage.setItem("token", res.response);
        localStorage.setItem("userPrefLang", 'en');
        this.nms.getPhoneNoByCardHolder(this.cardNo,this.membershipNbr).subscribe((res: any) => {
          if (res.code == "SUCCESS") {
            if (res.response.status != null) {
              if (res.response.status === "A") {
                this.phoneNbr = res.response.phoneNbr;
              } else if (res.response.status === "MEMBERSHIP_INACTIVE") {
                this.memebershipStatus = "MEMBERSHIP_INACTIVE";
              } else if (res.response.status === "CARD_INACTIVE") {
                this.memebershipStatus = "CARD_INACTIVE";
              }
            }
          }
        });
      }
    });
    /*
    this.user.getUserContent().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        localStorage.setItem("token", res.response);
        localStorage.setItem("userPrefLang", 'en');
        this.nms.fetchCard(cardId,memberId).subscribe((res: any) => {
          this.documentLoaded = true;
          if (res.code === "SUCCESS") {
            this.documentLoaded = true;
            this.cardDetails = res.response;
            this.phoneNbr = this.cardDetails.phoneNbr;
            this.membershipId = this.cardDetails.maMembershipId;
            this.status = this.cardDetails.status;
            this.documentId = this.cardDetails.documentId;
            if (this.cardDetails.documentId != null) {
              this.memberService.getDocuments(this.cardDetails.documentId, this.cardDetails.maMembershipId).subscribe((res: any) => {
                if (res.code === "SUCCESS") {      
                  
                  for(let list of res.response.filesList) {
                    let temp:any = {};
                    temp.vaultId = list.vaultId;
                    this.photo = list.file;
                  }
                  this.make_primaryCard(this.photo);
                  
                }
              });
            }
          } else {
            
          }
        });
      }
    });*/
   
  }

  getEcardInfo() {
    this.nms.fetchCard(this.cardNo,this.membershipNbr).subscribe((res: any) => {
      this.documentLoaded = true;
      if (res.code === "SUCCESS") {
        this.documentLoaded = true;
        this.cardDetails = res.response;
        this.phoneNbr = this.cardDetails.phoneNbr;
        this.membershipId = this.cardDetails.maMembershipId;
        this.status = this.cardDetails.status;
        this.documentId = this.cardDetails.documentId;
        if (this.cardDetails.filesList != null) {
          for(let list of this.cardDetails.filesList) {
            let temp:any = {};
            temp.vaultId = list.vaultId;
            this.photo = list.file;
          }
          this.make_primaryCard(this.photo);
          
        }
      } else {
        
      }
    });
  }

 
  updateOTPstatus(event) {
    this.OTPverified = event;
    this.getEcardInfo();
  }
  OTPGenerated(event) {
    this.otpGenerated = event;
  }

  contactInfo() {
    var otpInfo: any = {};
    otpInfo.membershipNbr = this.membershipNbr;
    otpInfo.phoneNbr = this.phoneNbr;
    otpInfo.cardHolderNbr = this.cardNo;
    otpInfo.category = "ONBOARDING_OTP";
    otpInfo.apiType = "MEMBER_VERIFY";
    return otpInfo;
  }
  
  printCard(cardHolderType, cardHolderNbr) {

      let nodeElement: any;
      if (cardHolderType === 'P') {
        nodeElement = document.getElementById('photoID');
      } else {
        nodeElement = document.getElementById('secondaryID');
      }
      var canvas = document.getElementById("canvas");

      var imageData = this.canvasToImage("#fff", canvas);
      imageData = imageData.replace("data:image/jpeg;base64,", "");
      this.nms.fetchPDFCard(this.cardNo,this.membershipNbr, imageData).subscribe((res: any) => {
        const linkSource = 'data:application/pdf;base64,' + res.response;
          const downloadLink = document.createElement("a");
          const fileName = "BestPrice_Ecard.pdf";

          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        });
  }

  printCard1(cardHolderType, cardHolderNbr) {
    let nodeElement: any;
    if (cardHolderType === 'P') {
      nodeElement = document.getElementById('photoID');
    } else {
      nodeElement = document.getElementById('secondaryID');
    }
    var canvas = document.getElementById("canvas");
    this.saveCanvasAs1(canvas, 'Bestprice_eCard.jpeg');

  }

  saveCanvasAs(canvas, fileName) {
    var imageData = this.canvasToImage("#fff", canvas);
    var doc = new jsPDF();
    doc.addImage(imageData, 'JPEG', 15, 40, 150, 75);
   doc.save('BestPrice_ECard');
  }


  saveCanvasAs1(canvas, fileName) {
    //var imageData = this.canvasToImage("#fff", canvas);
    // get image data and transform mime type to application/octet-stream
   var  canvasDataUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
         //window.location.href=canvasDataUrl; 
      
    var link = document.createElement('a'); // create an anchor tag

    
    link.setAttribute('href', canvasDataUrl);
    link.setAttribute('target', '_blank');
    link.setAttribute('download', fileName);
    link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  }

  
 

  make_primaryCard(memberPhoto) {
      this.context = (<HTMLCanvasElement>this.canvasRef.nativeElement).getContext(
        '2d');
      if (this.cardDetails.cardHolderType === 'P') {
        this.element = this.primaryImg.nativeElement;
      } else {
        this.element = this.addonImg.nativeElement;
      }
      let profile_image = new Image();
      profile_image.src = 'data:image/png;base64,' + memberPhoto;
   this.ecardValue = "11734" + this.cardDetails.cardHolderNbr + "0" + ('00000000'+ this.cardDetails.membershipNbr).slice(-9);
      JsBarcode("#eCardBarCode", this.ecardValue, {
        format: "CODE128",
        lineColor: "#000000",
        displayValue: false,
        background: "#ffffff",
        margin: 0
      });
      
      setTimeout(() => {        
        this.context.drawImage(this.element, 0, 0, 320, 200);
        setTimeout(() => {
         
          let barCode_image = new Image();
          barCode_image.src = document.getElementById("eCardBarCode").getAttribute('src');
          this.context.drawImage(barCode_image, 15, 155, 190, 30);
          this.context.drawImage(profile_image, 220, 105, 90, 80);
          this.make_cardNumber();
          this.make_cardHolderName();
          this.make_cardDesc();
          this.make_cardType();
          this.make_cardDuration();  
        }, 1000);        
      }, 1000);
    
        var cardNumberColor ="#ffffff";
        var cardHolderNameColor ="#125395";
        var cardDescColor ="#545859";
        var cardTypeColor ="#344068";
        var cardDurationColor ="#344068";
    }

    make_cardNumber() {
      var cardNumberColor ="#125395";
      this.context.fillStyle = cardNumberColor;
      this.context.textBaseline = 'middle';
      this.context.font = "bold 15px 'Arial'";
      this.context.fillText(this.ecardValue, 15,41);
    }

    make_cardHolderName() {
      var cardHolderNameColor ="#125395";
     var cardHolderName = this.cardDetails.firstName + ' ' + ' ' + this.cardDetails.lastName;
  //   var cardHolderName = "GGGGGGGGGG" + ' ' + "GGGGGGG";
      this.context.fillStyle = cardHolderNameColor;
      this.context.textBaseline = 'middle';
      this.context.font = "bold 13px 'Arial'";
      this.make_textWrap(cardHolderName, 80);    
    }

    make_cardDesc() {
      var cardDescColor ="#545859";
    //  var cardDesc = "Premanand Premanand Premanand Premanand";
      var cardDesc = this.cardDetails.businessName;
      this.context.fillStyle = cardDescColor;
      this.context.textBaseline = 'middle';
      this.context.font = "11px 'Arial'";
      var cardHolderName = this.cardDetails.firstName + ' ' + ' ' + this.cardDetails.lastName;
    //  var cardHolderName = "GGGGGGGGGG" + ' ' + "GGGGGGG";
       if(cardHolderName.length > 27) {
        this.make_textWrap(cardDesc, 110);
        this.context.font = "10px 'Arial'";
      } else {
        this.make_textWrap(cardDesc, 100);
        this.context.font = "11px 'Arial'";
      } 
      
    }

    make_textWrap(text, yPosition) {
		/* ======= code for text-wrap to multiple line starts ============ */
        var text = text;
        var max_width  = 250;
        var fontSize   =  11;
        var lines      =  new Array();
        var width = 0, i, j;
        var result;        
        // Start calculation
        while ( text.length ) {
          for( i=text.length; this.context.measureText(text.substr(0,i)).width > max_width; i-- );        
          result = text.substr(0,i);        
          if ( i !== text.length )
            for( j=0; result.indexOf(" ",j) !== -1; j=result.indexOf(" ",j)+1 );          
          lines.push( result.substr(0, j|| result.length) );
          width = Math.max( width, this.context.measureText(lines[ lines.length-1 ]).width );
          text  = text.substr( lines[ lines.length-1 ].length, text.length );
        }  
        // Calculate canvas size, add margin
       // ctx.width  = 14 + width;
      //  ctx.height =  8 + ( fontSize + 5 ) * lines.length;
        // Render
        for ( i=0, j=lines.length; i<j; ++i ) {
          this.context.fillText( lines[i].toUpperCase(), 15, yPosition + fontSize + (fontSize+2) * i,185 );
        }
        /* ======= code for text-wrap to multiple line ends ============ */
	}

     make_cardType() {
      var cardTypeColor ="#344068";
      
      if (this.cardDetails.cardHolderType === 'P') {
        var cardType = "Primary Member";
      } else {
        var cardType = "Secondary Member";
      }
      
      this.context.fillStyle = cardTypeColor;
      this.context.textBaseline = 'middle';
      this.context.font = "10px 'Arial'";
      this.context.fillText(cardType, 15, 68);
    }

     make_cardDuration() {
      var cardDurationColor ="#344068";
      var cardPipe="|";
      var cardDurationStart = "Since " + this.datePipe.transform(this.cardDetails.startDate, 'MM yyyy');
      var cardDurationEnd = "Valid Thru "  + this.datePipe.transform(this.cardDetails.nextRenewalDate, 'MM yyyy');
      this.context.fillStyle = cardDurationColor;
      this.context.textBaseline = 'middle';
      this.context.font = "10px 'Arial'";
     var cardHolderName = this.cardDetails.firstName + ' ' + ' ' + this.cardDetails.lastName;
     var cardDesc = this.cardDetails.businessName;
     // var cardDesc = "Premanand Premanand Premanand Premanand";
    //var cardHolderName = "GGGGGGGGGG" + ' ' + "GGGGGGG";
      if(cardHolderName.length > 27 || cardDesc.length > 27) {
        this.context.fillText(cardDurationStart, 15, 145);
        this.context.fillText(cardPipe, 90, 145);
        this.context.fillText(cardDurationEnd, 105, 145);
      } else {
        this.context.fillText(cardDurationStart, 15, 132);
        this.context.fillText(cardPipe, 90, 132);
        this.context.fillText(cardDurationEnd, 105, 132);
      } 
     
    }


  canvasToImage(backgroundColor, canvas){
      //cache height and width        
      var w = 320;
      var h = 200;      
      var data;
      
      //get the current ImageData for the canvas.
      data = this.context.getImageData(0, 0, w, h);
      
      //store the current globalCompositeOperation
      var compositeOperation = this.context.globalCompositeOperation;
      
      //set to draw behind current content
      this.context.globalCompositeOperation = "destination-over";
      
      //set background color
      this.context.fillStyle = backgroundColor;
      
      //draw background / rect on entire canvas
      this.context.fillRect(0,0,w,h);
      
      //get the image data from the canvas
      var imageData = canvas.toDataURL("image/jpeg");
      
      //clear the canvas
      this.context.clearRect (0,0,w,h);
      
      //restore it with original / cached ImageData
      this.context.putImageData(data, 0,0);
      
      //reset the globalCompositeOperation to what it was
      this.context.globalCompositeOperation = compositeOperation;
      
      //return the Base64 encoded data url string
      return imageData;
  }



  downloadImg() {
    
    var canvas = document.getElementById("canvas");
  //  var img    = canvas.toDataURL("image/png");
   // var image = node.toDataURL("image/jpeg").replace("image/png", "image/octet-stream");  // here is the most important part because if you dont replace you will get a DOM 18 exception.

  }

  getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;

        // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
          return "Windows Phone";
      }

      if (/android/i.test(userAgent)) {
          return "Android";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent)) {
          return "iOS";
      }

      return "unknown";
  }
}
